import { resolveImagePath } from "@/utils/imageMap.ts";

interface NavigationItem {
  href: string;
  image: string;
  alt: string;
  text: string;
}

const navigationItems: NavigationItem[] = [
  {
    href: "/attitude_indicators",
    image: "/images/Attitude_Indicators.png",
    alt: "Attitude Indicators",
    text: "ATTITUDE INDICATORS"
  },
  {
    href: "/directional_indicators", 
    image: "/images/Directional_indicators.png",
    alt: "Directional Indicators",
    text: "DIRECTIONAL INDICATORS"
  },
  {
    href: "/turn_indicators",
    image: "/images/Turn_indicators.png", 
    alt: "Turn Indicators",
    text: "TURN INDICATORS"
  },
  {
    href: "/esp_battery",
    image: "/images/Battery_Backup.png",
    alt: "Battery Backup", 
    text: "BATTERY BACKUP"
  },
  {
    href: "/tachs",
    image: "/images/Tachs_and_More.png",
    alt: "Tachs & More",
    text: "TACHS & MORE"
  }
];

export function LeftSidebar() {
  return (
    <div className="bg-gray-100 min-h-screen w-80 p-4 border-r border-gray-200">
      {/* Welcome Text */}
      <div className="mb-8">
        <p className="text-blue-800 font-bold text-lg leading-tight">
          <span className="text-2xl">W</span>elcome to the Home Page for 
          <br />
          RC Allen Instruments.
        </p>
      </div>

      {/* Navigation Links */}
      <div className="space-y-4">
        {navigationItems.map((item, index) => (
          <a
            key={index}
            href={item.href}
            className="block hover:opacity-80 transition-opacity"
          >
            <img
              src={resolveImagePath(item.image)}
              alt={item.alt}
              className="w-full h-auto rounded border border-gray-300 shadow-sm hover:shadow-md transition-shadow"
            />
          </a>
        ))}
      </div>

      {/* Copyright */}
      <div className="mt-8 text-xs text-gray-600 text-center">
        <p>Copyright</p>
        <p>Kelly Manufacturing Company</p>
      </div>
    </div>
  );
}